import { render, staticRenderFns } from "./NewMedia.vue?vue&type=template&id=12b56a33&scoped=true"
import script from "./NewMedia.vue?vue&type=script&lang=js"
export * from "./NewMedia.vue?vue&type=script&lang=js"
import style0 from "./NewMedia.vue?vue&type=style&index=0&id=12b56a33&prod&scoped=true&lang=css"
import style1 from "./NewMedia.vue?vue&type=style&index=1&id=12b56a33&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b56a33",
  null
  
)

export default component.exports